import PopOver from "../../../../../components/View/PopOver";
import { ActionIcon, Stack, Tooltip } from "@mantine/core";
import { IconDots } from "@tabler/icons-react";
import UnsubscribeProspect from "./UnsubscribeProspect";
import ZapierSyncer from "../../titleSection/zapier/ZapierSyncer";
import DeleteProspect from "./DeleteProspect";
import ExcludeProspect from "./exclude/ExcludeProspect";
import { useLanguage } from "../../../../../stores/LanguageStore";
import MakeSyncer from "../../titleSection/zapier/make/MakeSyncer";
import MarkAsNew from "./MarkAsNew";
import MarkAsNewConversation from "./MarkAsNewConversation";

const MoreActions = ({ inside, current, container, inTable, handleLoading }) => {
  const lang = useLanguage((s) => s.language);
  return (
    <PopOver
      opener={(handleOpen, ref) =>
        inside || inTable ? (
          <ActionIcon
            ref={ref}
            variant={inTable ? "subtle" : "light"}
            color="primary"
            onClick={handleOpen}
            ml={inTable ? 0 : "auto"}
          >
            <IconDots size={18} />
          </ActionIcon>
        ) : (
          <Tooltip label={lang.table.more_actions}>
            <ActionIcon
              variant="subtle"
              ref={ref}
              color="primary"
              onClick={handleOpen}
              pos={"absolute"}
              right={0}
              top={0}
              style={{
                borderTopLeftRadius: 0,
                borderBottomRightRadius: 0,
              }}
              className="hover-target"
            >
              <IconDots size={18} />
            </ActionIcon>
          </Tooltip>
        )
      }
      popoverChildren={(handleClose) => (
        <Stack gap={0}>
          {!current?.new_reply && (
            <MarkAsNew
              closeMenu={() => {
                handleLoading?.()
                handleClose()
              }}
              current={current}
              containerId={container.id}
            />
          )}
          {!current?.new_first_reply && (
            <MarkAsNewConversation
              closeMenu={() => {
                handleLoading?.()
                handleClose()
              }}
              current={current}
              containerId={container.id}
            />
          )}
          <ZapierSyncer
            closeMenu={() => {
              handleLoading?.()
              handleClose()
            }} current={current} />

          <MakeSyncer
            closeMenu={() => {
              handleLoading?.()
              handleClose()
            }} current={current} />

          <ExcludeProspect current={current} closeMenu={() => {
            handleLoading?.()
            handleClose()
          }} />

          <UnsubscribeProspect
            current={current}
            closeMenu={() => {
              handleLoading?.()
              handleClose()
            }}
            inPrm
          />

          <DeleteProspect
            closeMenu={() => {
              handleLoading?.()
              handleClose()
            }}
            current={current}
            container={container}
          />
        </Stack>
      )}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      sx={{ zIndex: "200 !important" }}
    />
  );
};

export default MoreActions;
